// import "./modules/HelloWorld";

// Some cool modules
import './modules/Animate'
import './modules/ToggleBodyClass'
import './modules/Tabs'
import './modules/Accordion'
import './modules/Dropdown'
// import "./modules/AjaxForm";
// import "./modules/WooCart";
// import "./modules/AjaxForm";
// import "./modules/ScrollClass";
// import "./modules/Videos";

document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('.hamburger')
  const menu = document.querySelector('.main-menu')
  const pageHeader = document.querySelector('#pageHeader')
  const submenuToggles = document.querySelectorAll('.submenu-toggle')
  const submenuLabels = document.querySelectorAll('.submenu-label')

  // Hamburger menu toggle
  hamburger.addEventListener('click', () => {
    menu.classList.toggle('active')
  })

  // Přidání funkcionalita pro kliknutí na submenu-label (Pouze název)
  submenuLabels.forEach(label => {
    label.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const menuItem = label.closest('.has-submenu')
      menuItem.classList.toggle('submenu-open')
      const toggle = menuItem.querySelector('.submenu-toggle')
      toggle.classList.toggle('active')
      const submenu = menuItem.querySelector('.submenu')
      submenu.classList.toggle('active')
    })
  })

  // Submenu toggle pro mobilní zobrazení
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const menuItem = toggle.closest('.has-submenu')
      menuItem.classList.toggle('submenu-open')
      toggle.classList.toggle('active')
      const submenu = menuItem.querySelector('.submenu')
      submenu.classList.toggle('active')
    })
  })

  // Fixed header při scrollování
  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      pageHeader.classList.add('fixed')
    } else {
      pageHeader.classList.remove('fixed')
    }
  })
})